import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { ShopForm } from "pages/shopManager/ShopForm";
import { getShopKorEng, updateShop } from "shared/api/ShopApi";

function EditItem() {
  const { shopId } = useParams();
  const [loadedData, setLoadedData] = useState(null);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const fetched = await getShopKorEng(shopId);
        if (!cancelled) setLoadedData(fetched);
      } catch (error) {
        if (!cancelled) setLoadError("HGU샵 정보를 불러오지 못했습니다.");
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [shopId]);

  const initialValues = loadedData
    ? {
        name: loadedData.name,
        title: loadedData.title,
        category: loadedData.category,
        content: loadedData.content,
        engTitle: loadedData.engTitle,
        engContent: loadedData.engContent,
        pin: loadedData.pin,
        inProgress: loadedData.inProgress,
        image: loadedData.image,
      }
    : null;

  return (
    <ShopForm
      mode="edit"
      initialValues={initialValues}
      isLoading={!loadedData && !loadError}
      loadError={loadError}
      onSubmit={(data) => updateShop(loadedData.id, data)}
    />
  );
}

export default EditItem;
